import { createSlice } from '@reduxjs/toolkit';
import { fetchAllConfigs } from './ConfigsThunks';

const initialState = {
  configs: {},
  isFetching: false,
  error: null,
};

export const configsSlice = createSlice({
  name: 'configs',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllConfigs.pending, (state) => {
        state.isFetching = true;
        state.error = null;
      })
      .addCase(fetchAllConfigs.fulfilled, (state, action) => {
        state.isFetching = false;
        state.error = null;
        state.configs = action.payload.data;
      })
      .addCase(fetchAllConfigs.rejected, (state) => {
        state.isFetching = false;
        state.error = 500;
      });
  },
});

export default configsSlice.reducer;
